import { MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo, scrollToId } from "@/components/Navbar";
import { waGeneral, WA_DISPLAY } from "@/lib/whatsapp";

export default function Footer() {
  return (
    <footer className="bg-ink text-paper pt-16 pb-8 overflow-hidden" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <Logo size={44} />
              <div className="leading-none">
                <span className="font-display font-bold text-2xl block">Kuki</span>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-paper/60">Impresiones</span>
              </div>
            </div>
            <p className="text-paper/60 mt-4 font-medium text-sm leading-relaxed max-w-xs">
              Librería & Novedades en Luque. Papelería con chispa para tu cole, tu oficina y tus regalos.
            </p>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] font-bold text-kyellow mb-4">Navegación</h4>
            <ul className="space-y-2.5 font-semibold text-sm">
              <li><a href="#catalogo" onClick={scrollToId("#catalogo")} className="hover:text-kyellow transition-colors">Catálogo</a></li>
              <li><a href="#pedido" onClick={scrollToId("#pedido")} className="hover:text-kyellow transition-colors">Hacer un pedido</a></li>
              <li><a href="#como-comprar" onClick={scrollToId("#como-comprar")} className="hover:text-kyellow transition-colors">Cómo comprar</a></li>
              <li><a href="#nosotros" onClick={scrollToId("#nosotros")} className="hover:text-kyellow transition-colors">Nosotros</a></li>
              <li><Link to="/admin" className="hover:text-kyellow transition-colors">Admin</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] font-bold text-kyellow mb-4">Contacto</h4>
            <p className="text-paper/70 text-sm font-medium">Fotógrafos del Chaco c/ San Juan, Luque</p>
            <p className="text-paper/70 text-sm font-medium mt-1">WhatsApp: {WA_DISPLAY}</p>
            <a href={waGeneral()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-cta"
              className="mt-4 h-11 px-5 inline-flex items-center gap-2 rounded-full border-2 border-kyellow bg-kyellow text-ink font-bold text-sm hover:-translate-y-0.5 transition-transform">
              <MessageCircle size={16} strokeWidth={2.5} /> Pedir ahora
            </a>
          </div>
        </div>
      </div>
      <div className="font-display font-extrabold text-[22vw] leading-none text-center text-stroke opacity-25 select-none pointer-events-none -mb-[6vw] mt-8">
        KUKI
      </div>
      <p className="text-center text-paper/40 text-xs font-medium relative">© {new Date().getFullYear()} Kuki Impresiones — Todos los derechos reservados.</p>
    </footer>
  );
}
